// extracted by mini-css-extract-plugin
export default {"button_next":"InternalCreateCard_button_next__ZM0xL","caption":"InternalCreateCard_caption__qJ3GK","link":"InternalCreateCard_link__PPmnM"};